import { render } from "./InquiryDetails.vue?vue&type=template&id=0f6e4a76&scoped=true"
import script from "./InquiryDetails.vue?vue&type=script&lang=js"
export * from "./InquiryDetails.vue?vue&type=script&lang=js"

import "./InquiryDetails.vue?vue&type=style&index=0&id=0f6e4a76&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6e4a76"]])

export default __exports__